<template>
  <div>
    <div class="d-flex align-items-center">
      <button
        class="btn"
        :style="{
          backgroundColor: buttonColor.hex || '#ffffff',
          color: (buttonColor.hex || '#ffffff') === '#ffffff' ? '#000000' : '#ffffff',
          border: '1px solid #ccc',
          fontWeight: 'bold',
        }"
        @click="showModal = true"
      >
        {{ $t("common.choose_color") }}
      </button>
      <a href="" @click.prevent="resetColor()" style="margin-left: 8px; color: #dc3545; text-decoration: underline">
        {{ $t("common.delete") }}
      </a>
    </div>
    <DxPopup
      :visible="showModal"
      v-if="showModal"
      :title='$t("common.choose_color")'
      :show-title="true"
      :width="500"
      :height="520"
      :show-close-button="true"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      @hiding="showModal = false"
    >
      <chrome-picker :value="color" @input="updateColor" style="width: 350px" />
      <div style="margin-top: 16px; padding-bottom: 20px">
        <strong>HEX:</strong> {{ color.hex }}<br />
        <strong>RGB:</strong> {{ color?.rgba?.r }}, {{ color?.rgba?.g }}, {{ color?.rgba?.b }}
      </div>
      <div class="d-flex align-items-center">
      <button style="margin-top: 5px; border: 1px solid #ccc;" class="btn btn-primary" @click="confirmColor"> {{ $t("common.ok") }}</button>
      <button style="margin-top: 5px; margin-left: 15px; border: 1px solid #ccc;" class="btn btn-secondary" @click="showModal = false"> {{ $t("common.cancel") }}</button>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { Chrome } from "vue-color";
import DxPopup from "devextreme-vue/popup";

export default {
  name: "ColorModalPicker",
  components: { "chrome-picker": Chrome, DxPopup },
  props: {
    value: { type: String, default: "#ffffff" },
    rowData: { type: Object, default: () => ({}) },
  },
  computed: {
    buttonColor() {
      return {
        hex: this.selectedColor.hex || this.value,
        rgba: this.selectedColor.rgba || { r: 0, g: 0, b: 0 },
      };
    },
  },
  data() {
    return {
      showModal: false,
      color: {
        hex: this.value,
        rgba: { r: 0, g: 0, b: 0 },
      },
      selectedColor: {
        hex: this.value,
        rgba: { r: 0, g: 0, b: 0 },
      },
    };
  },
  watch: {
    value(val) {
      this.selectedColor.hex = val;
    },
  },
  methods: {
    updateColor(newColor) {
      this.color = newColor;
    },
    confirmColor() {
      this.showModal = false;
      this.selectedColor = this.color;
      this.$emit("confirmColorChange", this.color.hex, this.rowData);
      this.$forceUpdate();
    },
    resetColor() {
      this.selectedColor = { hex: "#ffffff", rgba: { r: 0, g: 0, b: 0 } };
      this.color = { hex: "#ffffff", rgba: { r: 0, g: 0, b: 0 } };
      this.$emit("confirmColorChange", null, this.rowData);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped></style>
